import React from 'react';
import { WowImage, ImageResizeOptions, IconButton, DotNavigation } from 'wix-ui-tpa/cssVars';
import { dataHooks } from '../../dataHooks';
import { ChevronLeft, ChevronRight } from '@wix/wix-ui-icons-common/on-stage';
import { classes } from './SimpleGallery.st.css';
import { useGalleryLogic } from './Gallery.logic';
export const SimpleGallery = _ref => {
  let {
    images,
    currentImageIndex,
    dataHook,
    biFunctions,
    nextButtonAriaLabel,
    previousButtonAriaLabel
  } = _ref;
  const {
    currentImage,
    goToPrevious,
    goToNext,
    hasMultipleImages,
    activeIndex
  } = useGalleryLogic({
    images,
    currentImageIndex,
    biFunctions
  });
  return /*#__PURE__*/React.createElement("div", {
    className: `${classes.imageContainer}`,
    "data-active-index": activeIndex
  }, /*#__PURE__*/React.createElement(WowImage, {
    fluid: true,
    shouldUseLQIP: true,
    stretchImage: true,
    "data-hook": dataHooks.gallery.image(dataHook ?? ''),
    resize: ImageResizeOptions.cover,
    sourceHeight: currentImage == null ? void 0 : currentImage.sourceHeight,
    sourceWidth: currentImage == null ? void 0 : currentImage.sourceWidth,
    src: currentImage.src
  }), hasMultipleImages && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": previousButtonAriaLabel,
    className: `${classes.navigationArrow} ${classes.leftArrow}`,
    icon: /*#__PURE__*/React.createElement(ChevronLeft, {
      size: 32
    }),
    onClick: goToPrevious,
    "data-hook": dataHooks.gallery.previousButton(dataHook ?? '')
  }), /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": nextButtonAriaLabel,
    className: `${classes.navigationArrow} ${classes.rightArrow}`,
    icon: /*#__PURE__*/React.createElement(ChevronRight, {
      size: 32
    }),
    onClick: goToNext,
    "data-hook": dataHooks.gallery.nextButton(dataHook ?? '')
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.dotNavigationWrapper
  }, /*#__PURE__*/React.createElement(DotNavigation, {
    currentIndex: activeIndex,
    length: images.length,
    "data-hook": dataHooks.gallery.dotNavigation(dataHook ?? '')
  }))));
};
//# sourceMappingURL=SimpleGallery.js.map